import { render, staticRenderFns } from "./zx.vue?vue&type=template&id=2a8b0138&scoped=true&"
import script from "./zx.vue?vue&type=script&lang=js&"
export * from "./zx.vue?vue&type=script&lang=js&"
import style0 from "./zx.vue?vue&type=style&index=0&id=2a8b0138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8b0138",
  null
  
)

component.options.__file = "zx.vue"
export default component.exports